import React from 'react';

import { ValueType, EditProps } from './types';

type InlineEditContextType = {
  updateValue?: (value: ValueType) => void;
  setEditMode?: (editMode: boolean) => void;
  inputOnChange?: React.ChangeEventHandler;
  onEditExit?: (val: ValueType, editProps?: EditProps) => void;
};

const InlineEditContext = React.createContext<InlineEditContextType>({});

export default InlineEditContext;
